import { useEffect, useState } from 'react'

import { ReactNode } from 'react'
import Sidebar from '../Admin/Sidebar'
import Header from '../Admin/Header'
import { ToastContainer } from 'react-toastify'
import { currentUser } from '../../lib/auth'
import { useNavigate } from 'react-router-dom'

export default function AdminLayout({ children }: { children: ReactNode }) {
  const [isMobileOpen, setIsMobileOpen] = useState(false)
  const navigate = useNavigate()

  useEffect(() => {
    const user = currentUser()
    if(user && user.role !== 'ADMIN'){
      navigate('/login')
    }
  }, [])

  return (
    <div className="min-h-screen flex bg-gray-100 dark:bg-gray-900">
      <ToastContainer />
      <Sidebar isMobileOpen={isMobileOpen} setIsMobileOpen={setIsMobileOpen} />
      <div className="flex-1 flex flex-col">
        <Header toggleMobileSidebar={() => setIsMobileOpen(!isMobileOpen)} />
        <main className="flex-1 p-4 text-gray-900 dark:text-gray-100">
          {children}
        </main>
      </div>
    </div>
  )
}

